import { h } from 'vue';
import { notification } from 'ant-design-vue';

import StcNotificationContent from './stc-notification-content.vue';
import type { StcNotificationOptions, StcNotificationType } from './types';

import './stc-notification.scss';

const showNotificationByType = (
  type: StcNotificationType,
  description: string,
  title?: string,
  options?: Omit<StcNotificationOptions, 'description' | 'title' | 'type'>,
): void => {
  showStcNotification({
    description,
    title,
    type,
    ...options,
  });
};

export function showStcNotification(options: StcNotificationOptions): void {
  notification.open({
    message: h(StcNotificationContent, {
      type: options.type ?? 'error',
      title: options.title,
      description: options.description,
    }),
    placement: options.placement ?? 'topRight',
    duration: options.duration ?? 10,
    class: 'stc-notification',
    icon: null,
  });
}

export function showStcErrorNotification(
  description: string,
  title?: string,
  options?: Omit<StcNotificationOptions, 'description' | 'title' | 'type'>,
): void {
  showNotificationByType('error', description, title, options);
}

export function showStcSuccessNotification(
  description: string,
  title?: string,
  options?: Omit<StcNotificationOptions, 'description' | 'title' | 'type'>,
): void {
  showNotificationByType('success', description, title, options);
}

export function showStcWarningNotification(
  description: string,
  title?: string,
  options?: Omit<StcNotificationOptions, 'description' | 'title' | 'type'>,
): void {
  showNotificationByType('warning', description, title, options);
}

export function showStcInfoNotification(
  description: string,
  title?: string,
  options?: Omit<StcNotificationOptions, 'description' | 'title' | 'type'>,
): void {
  showNotificationByType('info', description, title, options);
}
